module.exports = {"confirmBtn":"Ok"}


//////////////////
// WEBPACK FOOTER
// ./src/app/elements/Modal/data.json
// module id = 1817
// module chunks = 0